<template>
  <div :class="layoutStyle" class="product px-0 px-sm-1 mb-2">
    <div v-if="product.is_hot || product.is_new" class="tag-container">
      <div v-if="product.is_hot" class="tag hot" :class="tagClass(product)" title="Hot Item">
        <i class="fas fa-fire icon"></i>
      </div>
      <div v-if="product.is_new" class="tag new" :class="tagClass(product)" title="New Item">
        <i class="fas fa-tools icon"></i>
      </div>
    </div>
    <p 
      v-if="showBuyAgain && (!this.product.is_hot && !this.product.is_new)"
      class="buy-again position-absolute badge badge-primary pl-3 py-2 pr-4"
    >
      Buy Again
    </p>
    <div class="card border h-100 position-relative product-container" :class="{'d-flex justify-content-end':!product.image_url}">
      <div v-if="product.sku && layoutStyle !== 'compact' && !custom" class="manufacturer_reference">
        <span>{{product.sku}}</span>
      </div>

      <inertia-link 
        :href="route(productLink, (product.single_bundle_product_id) ? product.single_bundle_product_id : product.id)" class="product-link"
        :class="{'mb-0': !product.image_url}"
      >
          <div v-if="product.image_url" class="product-image flex-center" :class="{'mt-0': custom}">
            <img :src="product.image_url" />
          </div>
          <div class="px-2 text-container" :class="{'pt-3': !product.image_url}">
            <p class="widget-product-manufacturer mb-0">
              {{ product.manufacturer }} 
              <span v-if="layoutStyle === 'compact'" class="font-weight-light">({{product.sku}})</span>
            </p>
            <p 
              v-if="showBuyAgain && (this.product.is_hot || this.product.is_new)"
              class="buy-again my-1 badge badge-primary pl-3 py-1 pr-4"
            >
              Buy Again
            </p>
            <p class="widget-product-title font-weight-bold mb-0">{{ product.name }}</p>
            <p v-if="custom" class="text-size-small text-secondary mb-1">{{product.sku}}</p>
            <p v-if="layoutStyle !== 'compact'" class="widget-product-description">{{ product.short_description }}</p>
          </div>

          <span v-if="layoutStyle != 'compact' && product.cartItemWithThisProduct" class="product-link text-size-small single-bundle-description mt-2 px-2">
            <p class="m-0 text-secondary"><i class="fas fa-shopping-cart fa-sm mr-2"></i>You have {{ product.cartItemWithThisProduct.linked_qty }} {{ product.cartItemWithThisProduct.product.sku }} in your cart</p>
            <p class="mb-0 mt-1 text-secondary">Includes {{ product.cartItemWithThisProductQty }} of this product</p>
          </span>
        </inertia-link>

        <VariationCartItems 
           v-if="layoutStyle != 'compact' && product.cartItemOptions && product.cartItemOptions.length > 0"
          ref="variation-cart-items"
          :product="product"
          :cart_items="cart_items"
          :productLink="productLink"
          @fillOption="fillOption"
        />

        <div class="px-2" v-if="isWholesale && product.user_price && layoutStyle != 'compact'">
          <p class="mt-2 mb-0 badge badge-primary pt-1 px-2">Customer Price: {{ formatDollars(product.user_price) }}</p>
        </div>

      <div class="cart-row pt-2 mt-2">
        <div class="h-100 pl-2 pb-2 pb-xl-0">
          <div class="widget-price mb-2 mb-xl-0">
            <PriceDisplay :product="product" />
          </div>
          <div class="cart-widget-icons shop-quantity">
            <template v-if="product.product_type == 'variation_main' || product.product_type == 'bundle_single_with_variation_included'">
              <jet-button v-if="product.attributes && product.attributes.length !== 1" btnStyle="outline-primary" :goesTo="route(productLink, product.id)" class="btn-sm">
                Select options...
              </jet-button>

              <div v-else>
                <template v-if="product.attributes">
                  <select 
                    v-model="selectedAttribute[product.id]" 
                    class="form-control form-control-sm mb-2">
                    <option selected disabled value="0">Select {{product.attributes[0].name}}</option>
                    <option v-for="value in product.attributes[0].values" :value="value" :key="value.value_id">{{value.value}}</option>
                  </select>

                  <div v-if="selectedAttribute[product.id]" class="mt-2 pb-2">
                    <ProductQty
                      ref="product-qty"
                      inputStyle="compact"
                      :product="selectedAttribute[product.id]"
                      :cart_items="cart_items"
                      :routes="routes"
                      @updateCartItems="updateCartItems"
                    />
                  </div>
                </template>
              </div>

            </template>
            <template v-else>
              <ProductQty
                :product="product"
                inputStyle="compact"
                :cart_items="cart_items"
                :routes="routes"
                :is_suggested="is_suggested" 
                :suggested_type="suggested_type"
                @updateCartItems="updateCartItems" 
              />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VariationCartItems from '@/Components/Shop/VariationCartItems'
  import PriceDisplay from '@/Components/Shop/PriceDisplay'
  import ProductQty from '@/Components/Shop/ProductQty'

  export default {
    components: {
      VariationCartItems,
      PriceDisplay,
      ProductQty
    },
    props: {
      product: Object,
      productLink: String,
      cart_items: Object,
      isWholesale: Boolean,
      routes: Object,
      layoutStyle: String,
      custom: Boolean,
      is_suggested: {
        type: Boolean,
        default: false
      },
      selectedAttribute: Object,
      suggested_type: {
        type: String,
        default: null
      },
    },
    computed: {
      showBuyAgain() {
        return this.product.my_count > 0 && this.layoutStyle !== 'compact'
      }
    },
    methods: {
      tagClass(product) {
        return product.is_new && product.is_hot ? 'both' : 'only'
      },
      fillOption(product, optionId) {
        const chosenAttribute = product.attributes[0].values.filter(value => {
          if (value.product_id === optionId) return value
        })

        if (chosenAttribute.length) this.selectedAttribute[product.id] = chosenAttribute[0]
      },
      updateCartItems() {
        this.$emit('getCartItems')
        this.$emit('updateCartItems')
      },
    }
  }
</script>
